// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__2s2R4","load":"Loader_load__+enCT","rotate":"Loader_rotate__Po8r4"};